export const select_park_id = (park_id) => {
    return {
        type : 'SELECT_PARK_ID',
        selected_park_id : park_id,
    };
}
